module.exports = __webpack_public_path__ + "static/media/courses.72e6fe62.svg";